import { CALL_API } from 'redux-api-middleware'
import { push } from 'react-router-redux'
import {
  LOAD_CATEGORY_REQUEST,
  LOAD_CATEGORY_SUCCESS,
  LOAD_CATEGORY_FAILURE,
  CREATE_SECTION,
  CREATE_LECTION,
  UPDATE_LOCATION_SECTION,
  UPDATE_LOCATION_LECTURE,
  APPEND_VIDEO_CREATE_COURSE,
  DETACH_VIDEO_CREATE_COURSE,
  UPLOAD_NEW_COURSE,
  UPDATE_COURSE_LANDING,
  UPDATE_COURSE_PRICING,
  UPDATE_ERROR_STATUS,
  UPDATE_FILE_LANDING,
  UPLOADING_FILE_COURSE,
  REMOVE_LECTURE,
  REMOVE_SECTION,
} from './types'

import {
  UPLOAD_FILE_NEW_COURSE_EP,
  UPLOAD_NEW_COURSE_EP,
} from '../constant'

import {
  token,
  UploadRequest,
} from '../utils'
const headers = {
  'x-session-token': token,
  'server-name': 'deknerd',
}
export const loadNewCourseCategory = (endpoint) => {
  return (dispatch) => {
    dispatch({
      [CALL_API]: {
        endpoint,
        method: 'GET',
        headers,
        types: [LOAD_CATEGORY_REQUEST, LOAD_CATEGORY_SUCCESS, LOAD_CATEGORY_FAILURE],
      },
    })
  }
}

export const handleCreateSection = ({ title }) => {
  return {
    type: CREATE_SECTION,
    data: {
      title,
    },
  }
}

export const handleCreateLecture = ({ index, title }) => {
  return {
    type: CREATE_LECTION,
    data: {
      index,
      title,
    },
  }
}

export const handleUpdateSection = (section) => {
  return {
    type: UPDATE_LOCATION_SECTION,
    data: {
      section,
    },
  }
}
export const handleUpdateLecture = (locationLecture) => {
  return {
    type: UPDATE_LOCATION_LECTURE,
    data: {
      locationLecture,
    },
  }
}

export const handleAppendFile = (objLocAndVideo) => {
  return {
    type: APPEND_VIDEO_CREATE_COURSE,
    data: {
      ...objLocAndVideo,
    },
  }
}

export const handleDetachFile = (objLoc) => {
  return {
    type: DETACH_VIDEO_CREATE_COURSE,
    data: {
      ...objLoc,
    },
  }
}

export const handleUploadCourse = (objNewCourse) => {
  const {
    courseLanding: {
      category: convertCategory,
      description,
      language,
      levels: convertLevels,
      productName,
      img400,
      img540,
      img960,
      videoExample,
    },
    coursePricing: {
      price,
    },
    course: { sections },
  } = objNewCourse
  const levels = convertLevels.map(level => JSON.parse(level))
  const category = [JSON.parse(convertCategory)]
  // const category = convertCategory.map(cat => JSON.parse(cat))
  const dataUpload = {
    productName,
    description,
    language,
    levels,
    category,
    sections,
    title: productName,
    coin: price,
  }
  UploadRequest({
    request: {
      url: UPLOAD_NEW_COURSE_EP,
      fields: {
        data: JSON.stringify(dataUpload),
      },
    },
    headers,
    files: videoExample !== undefined ? [img400, img540, img960, videoExample] : [img400, img540, img960],
  })
  return {
    type: UPLOAD_NEW_COURSE,
    data: {
      objNewCourse,
    },
  }
}

export const handleUploadFileCourse = (objNewCourse) => {
  const {
    uploader,
    courseLanding: {
      productName,
    },
  } = objNewCourse
  let files = []

  uploader.map(({ lectures }) => {
    if (lectures instanceof Object) {
      const lecture = Object.values(lectures)
      lecture.map((lec) => {
        lec.file.fileName = lec.file.uid
        return files.push(lec.file)
      })
    }
    return 0
  })
  return (dispatch) => {
    UploadRequest({
      request: {
        url: UPLOAD_FILE_NEW_COURSE_EP,
        // url: 'http://localhost:8000/upload',
        fields: {
          title: productName,
        },
      },
      headers,
      files,
      progress: value => dispatch({
        type: UPLOADING_FILE_COURSE,
        data: {
          title: productName,
          percent: value,
        },
      }),
    })
    dispatch({
      type: UPLOAD_NEW_COURSE,
      data: {
        objNewCourse,
      },
    })
    dispatch(push('/instructor/dashboard'))
  }
}
export const handleUploadFileCourseTest = (objNewCourse) => {
  const {
    uploader,
    courseLanding: {
      productName,
    },
  } = objNewCourse
  let files = []

  uploader.map(({ lectures }) => {
    if (lectures instanceof Object) {
      const lecture = Object.values(lectures)
      lecture.map((lec) => {
        lec.file.fileName = lec.file.uid
        return files.push(lec.file)
      })
    }
    return 0
  })
  return (dispatch) => {
    UploadRequest({
      request: {
        url: 'http://192.168.1.123:8080/api/v1.0/videocourse/upload',
        // url: 'http://localhost:8000/upload',
        fields: {
          title: productName,
        },
      },
      headers,
      files,
      progress: value => dispatch({
        type: UPLOADING_FILE_COURSE,
        data: {
          title: productName,
          percent: value,
        },
      }),
    })
    dispatch({
      type: UPLOAD_NEW_COURSE,
      data: {
        objNewCourse,
      },
    })
    // dispatch(push('/instructor/dashboard'))
  }
}

export const addInformations = (courseLanding) => {
  return {
    type: UPDATE_COURSE_LANDING,
    data: {
      courseLanding,
    },
  }
}

export const addPricing = (coursePricing) => {
  return {
    type: UPDATE_COURSE_PRICING,
    data: {
      coursePricing,
    },
  }
}

export const handleUpdateErrorStatus = (data) => {
  return {
    type: UPDATE_ERROR_STATUS,
    data,
  }
}

export const handleAppendFileToCourseLanding = (data) => {
  return {
    type: UPDATE_FILE_LANDING,
    data,
  }
}

export const handleRemoveSection = (data) => {
  return {
    type: REMOVE_SECTION,
    data,
  }
}
export const handleRemoveLecture = (data) => {
  return {
    type: REMOVE_LECTURE,
    data,
  }
}




// WEBPACK FOOTER //
// ./src/actions/newCourse.js